import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pill"]

  connect() {
    this.handleOnline = this.handleChange.bind(this, true)
    this.handleOffline = this.handleChange.bind(this, false)
    this.handleFetchSucceeded = this.handleFetchChange.bind(this, true)
    this.handleFetchFailed = this.handleFetchChange.bind(this, false)

    this.update()
    window.addEventListener("online", this.handleOnline)
    window.addEventListener("offline", this.handleOffline)
    window.addEventListener("hitl:fetch-succeeded", this.handleFetchSucceeded)
    window.addEventListener("hitl:fetch-failed", this.handleFetchFailed)
  }

  disconnect() {
    window.removeEventListener("online", this.handleOnline)
    window.removeEventListener("offline", this.handleOffline)
    window.removeEventListener("hitl:fetch-succeeded", this.handleFetchSucceeded)
    window.removeEventListener("hitl:fetch-failed", this.handleFetchFailed)
  }

  handleChange(isOnline) {
    this.setOnline(isOnline)
  }

  handleFetchChange(isOnline) {
    if (isOnline && !navigator.onLine) return

    this.setOnline(isOnline)
  }

  update() {
    this.setOnline(navigator.onLine)
  }

  setOnline(isOnline) {
    if (this.hasPillTarget) this.pillTarget.hidden = isOnline
  }
}
